import { isExternalUrl, localizeUrl, stripLocalePrefix } from "./localizeUrl"
import { DEFAULT_PUBLIC_LANG } from "@/lib/locale/toContentfulLocale"

function isHomepagePath(path: string, homepageSlug: string): boolean {
  const normalized = path.replace(/\/$/, "") || "/"
  const homepagePath = `/${homepageSlug}`.replace(/\/$/, "")
  return normalized === "/" || normalized === homepagePath
}

/** Server-safe: builds a localized URL from a nav item. */
export function cleanURLWithLang(
  item: any,
  lang: string = DEFAULT_PUBLIC_LANG,
  homepageSlug?: string | null,
): string {
  let additionalSegment = ``
  if (item?.pageLink?.__typename === "PageProductPage") {
    additionalSegment = `/products`
  }
  let url = ""
  if (
    item?.pageLink?.__typename === "ProductDetailPage" &&
    item?.pageLink?.slug
  ) {
    // `slug` is the source of truth for this page's URL — no link without one.
    url = `/products/${item.pageLink.slug}/buy`
  } else if (
    item?.pageLink?.__typename === "ProductTrialPage" &&
    item?.pageLink?.slug
  ) {
    // `slug` is the source of truth for this page's URL — no link without one.
    url = `/products/${item.pageLink.slug}/trial`
  } else if (item?.pageLink?.url) {
    url = item.pageLink.url
  } else if (item?.pageLink?.externalUrl) {
    url = item.pageLink.externalUrl
  } else if (item?.pageLink?.slug) {
    url = `${additionalSegment}/${item.pageLink.slug}`
  } else if (item?.__typename === "ExternalLink") {
    url = item.url || ""
  } else if (item?.url) {
    url = item.url
  }

  if (homepageSlug) {
    if (item?.pageLink?.slug === homepageSlug || item?.pageLink?.url === homepageSlug) {
      return `/${lang}`
    }
    if (url && !isExternalUrl(url) && isHomepagePath(url, homepageSlug)) {
      return `/${lang}`
    }
  }

  const localized = localizeUrl(url, lang)
  if (
    homepageSlug &&
    !isExternalUrl(localized) &&
    isHomepagePath(stripLocalePrefix(localized), homepageSlug)
  ) {
    return `/${lang}`
  }

  return localized
}
